// extracted by mini-css-extract-plugin
export var skipAnimation = "_2o-0";